export function normalize_phone_number(number) {
    return `${number}`.replace(/\D+/g, '');
}
export function str_slug(text) {
    let separator = '-';
    return text
        .toLowerCase()
        .replace('_', '-')
        .replace(new RegExp('[^a-z0-9-\\s]', 'g'), '')
        .replace(new RegExp('[-\\s]+', 'g'), separator)
        .replace(new RegExp('^[-\\s]+|[-\\s]+$', 'g'),'');
}

export function filterShippingMethods (location, shippingMethods) {
    let country = location?.country;
    let state = location?.state;

    if (!country || country.length == 0)
        country = 'US';

    if (!state || state.length == 0)
        state = 'AK';

    const rates = (shippingMethods.data[country] || shippingMethods.data["*"] || []).map((rate) => {
        return {
            name: rate.name,
            price: rate.price,
            key: rate.shopify_rate_id,
            label: `${rate.name} - $${rate.price}`,
        };
    });

    if (country == 'US' && (state == 'AK' || state == 'HI')) {
        (shippingMethods.custom.AKHI || [])
            .forEach((customRate, key) => {
                rates.push({
                    name: customRate.name,
                    price: customRate.price,
                    key: `custom-${key}`,
                    label: `${customRate.name} - $${customRate.price}`,
                })
            }); //custom shipping methods for Alaska/Hawaii
    } else if (shippingMethods.custom[country]) {
        (shippingMethods.custom[country] || [])
            .forEach((customRate, key) => {
                rates.push({
                    name: customRate.name,
                    price: customRate.price,
                    key: `custom-${key}`,
                    label: `${customRate.name} - $${customRate.price}`,
                })
            }); //custom shipping methods for Canada and US
    }

    rates.push({
        name: 'Free Shipping',
        price: 0,
        key: 'free',
        label: 'Free Shipping',
    });
    rates.push({
        name: 'Custom',
        price: 0,
        key: 'custom',
        label: 'Custom',
    });

    return rates;
}

export function getFormError (errors, name) {
    return errors?.[name]?.[0] || null;
}

export function getErrorMessage (error) {
    return error?.response?.data?.errors?.code?.[0]
        || error?.response?.data?.message
        || 'Something went wrong';
}

// Navigate to a Shopify admin path (e.g. '/draft_orders/123') from an embedded app.
// The host URL param is base64url-encoded and decodes to "store.myshopify.com/admin".
export function adminRedirect (path) {
    const raw = new URLSearchParams(window.location.search).get('host')
        ?? window.appBridgeConfig?.host;
    if (!raw) return;
    const decoded = atob(raw.replace(/-/g, '+').replace(/_/g, '/'));
    window.open(`https://${decoded}${path}`, '_top');
}
